module.exports = __webpack_public_path__ + "static/ubuntu-medium-b4e565dcfc8f6cb332be0fc03302ad99.woff2";